module.exports = __webpack_public_path__ + "img/des_muyu_4.8e14c157.jpg";